import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";

// Libraries
import { LazyLoadImageModule } from "ng-lazyload-image";
import { InlineSVGModule } from "ng-inline-svg";

// Pipes
import { SafeHtmlPipe } from "./pipes/safeHtml";
import { AsciiCheckPipe } from "./pipes/asciiCheck";

// Services
import { WordpressService } from "./services/wordpress.service";
import { MenuService } from "./services/menu.service";
import { HomeIntroService } from "./services/home-intro.service";
import { MetaDataService } from "./services/metadata.service";
import { EventsService } from "./services/events.service";
import { PrevUrlService } from "./services/prev-url.service";

// Guards
import { PageResolveGuard } from "./guards/page-resolve.guard";
import { JournalPostsResolveGuard } from "./guards/journal-posts-resolve.guard";
import { JournalPostResolveGuard } from "./guards/journal-post-resolve.guard";

// Pages
import { PageHomeComponent } from "./pages/page-home/page-home.component";
import { PageStyleguideComponent } from "./pages/page-styleguide/page-styleguide.component";
import { PageJournalComponent } from "./pages/page-journal/page-journal.component";
import { PageJournalPostComponent } from "./pages/page-journal-post/page-journal-post.component";
import { PagePressComponent } from "./pages/page-press/page-press.component";
import { PageCareersComponent } from "./pages/page-careers/page-careers.component";
import { PageGiftCardsComponent } from "./pages/page-gift-cards/page-gift-cards.component";
import { PageAccessibilityComponent } from "./pages/page-accessibility/page-accessibility.component";

// Components
import { PageSectionIntroComponent } from "./components/page-section-intro/page-section-intro.component";
import { NavigationComponent } from "./components/navigation/navigation.component";
import { TextareaComponent } from "./components/textarea/textarea.component";
import { HomeIntroductionComponent } from "./components/home-introduction/home-introduction.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HomeSectionMenuComponent } from "./components/home-section-menu/home-section-menu.component";
import { HomeSectionAboutComponent } from "./components/home-section-about/home-section-about.component";
import { ReservationsOverlayComponent } from "./components/reservations-overlay/reservations-overlay.component";
import { NavigationOverlayComponent } from "./components/navigation-overlay/navigation-overlay.component";
import { ScrollTextComponent } from "./components/scroll-text/scroll-text.component";
import { HomeSectionContactComponent } from "./components/home-section-contact/home-section-contact.component";
import { HomeSectionJournalComponent } from "./components/home-section-journal/home-section-journal.component";
import { HomeSectionPressComponent } from "./components/home-section-press/home-section-press.component";
import { LinksGridComponent } from "./components/links-grid/links-grid.component";
import { ContactComponent } from "./components/contact/contact.component";
import { MenuComponent } from "./components/menu/menu.component";
import { VideoBackgroundComponent } from "./components/video-background/video-background.component";
import { HomeSectionCrewComponent } from "./components/home-section-crew/home-section-crew.component";
import { CrewSlideshowComponent } from "./components/crew-slideshow/crew-slideshow.component";
import { SelectricComponent } from "./components/selectric/selectric.component";
import { SubpageHeroComponent } from "./components/subpage-hero/subpage-hero.component";
import { TextCalloutComponent } from "./components/text-callout/text-callout.component";
import { LogoComponent } from "./components/logo/logo.component";
import { JournalPostsGridComponent } from "./components/journal-posts-grid/journal-posts-grid.component";
import { JournalPostPreviewComponent } from "./components/journal-post-preview/journal-post-preview.component";
import { JournalPostHeroComponent } from "./components/journal-post-hero/journal-post-hero.component";
import { JournalPostNewsletterComponent } from "./components/journal-post-newsletter/journal-post-newsletter.component";
import { JournalPostContentComponent } from "./components/journal-post-content/journal-post-content.component";
import { PostShareComponent } from "./components/post-share/post-share.component";
import { HomeSectionEventsComponent } from "./components/home-section-events/home-section-events.component";
import { ImageGridComponent } from "./components/image-grid/image-grid.component";
import { SlideshowComponent } from "./components/slideshow/slideshow.component";
import { InterviewComponent } from "./components/interview/interview.component";
import { JournalPostRelatedComponent } from "./components/journal-post-related/journal-post-related.component";
import { NoticeOverlayComponent } from './components/notice-overlay/notice-overlay.component';

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    AsciiCheckPipe,
    PageHomeComponent,
    PageStyleguideComponent,
    PageSectionIntroComponent,
    NavigationComponent,
    TextareaComponent,
    HomeIntroductionComponent,
    FooterComponent,
    HomeSectionMenuComponent,
    HomeSectionAboutComponent,
    ReservationsOverlayComponent,
    NavigationOverlayComponent,
    ScrollTextComponent,
    HomeSectionContactComponent,
    HomeSectionJournalComponent,
    HomeSectionPressComponent,
    LinksGridComponent,
    ContactComponent,
    MenuComponent,
    VideoBackgroundComponent,
    HomeSectionCrewComponent,
    CrewSlideshowComponent,
    SelectricComponent,
    PagePressComponent,
    SubpageHeroComponent,
    TextCalloutComponent,
    PageJournalComponent,
    PageJournalPostComponent,
    LogoComponent,
    JournalPostsGridComponent,
    JournalPostPreviewComponent,
    JournalPostHeroComponent,
    JournalPostNewsletterComponent,
    JournalPostContentComponent,
    PostShareComponent,
    HomeSectionEventsComponent,
    ImageGridComponent,
    PageCareersComponent,
    PageGiftCardsComponent,
    PageAccessibilityComponent,
    SlideshowComponent,
    InterviewComponent,
    JournalPostRelatedComponent,
    NoticeOverlayComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LazyLoadImageModule,
    InlineSVGModule.forRoot()
  ],
  providers: [
    WordpressService,
    MenuService,
    HomeIntroService,
    MetaDataService,
    EventsService,
    PageResolveGuard,
    JournalPostsResolveGuard,
    JournalPostResolveGuard,
    PrevUrlService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
